/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getActivitiesQueryParamsSchema = z.object({
  Filters: z.string().optional(),
  SortOrder: z.string().optional(),
  PageNumber: z.coerce.number().int(),
  PageSize: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getActivities200Schema = z.object({
  items: z.array(
    z.object({
      id: z.coerce.number().int().optional(),
      employeeValue: z.coerce.number().int(),
      employeeLabel: z.coerce.string(),
      clientLabel: z.coerce.string(),
      clientValue: z.coerce.number().int(),
      projectValue: z.coerce.number().int().nullable(),
      projectLabel: z.coerce.string().nullable(),
      macroProjectValue: z.coerce.number().int().nullable(),
      macroProjectLabel: z.coerce.string().nullable(),
      costCenterLabel: z.coerce.string().nullable(),
      costCenterValue: z.coerce.number().int().nullable(),
      description: z.coerce.string().nullable().nullish(),
      date: z.string().date(),
      year: z.coerce.number().int(),
      month: z.coerce.number().int(),
      fromTime: z.string().time(),
      toTime: z.string().time(),
      effectiveHours: z.coerce.number(),
      km: z.coerce.number().nullable().nullish(),
      extraCosts: z.coerce.number().nullable().nullish(),
      costsDescription: z.coerce.string().nullable().nullish(),
    }),
  ),
  pageNumber: z.coerce.number().int(),
  totalPages: z.coerce.number().int().optional(),
  pageSize: z.coerce.number().int(),
  currentPageSize: z.coerce.number().int().optional(),
  currentStartIndex: z.coerce.number().int().optional(),
  currentEndIndex: z.coerce.number().int().optional(),
  totalCount: z.coerce.number().int().optional(),
  hasPrevious: z.boolean().optional(),
  hasNext: z.boolean().optional(),
  nextPageNumber: z.coerce.number().int().nullable().nullish(),
});

export const getActivitiesQueryResponseSchema = z.lazy(
  () => getActivities200Schema,
);
